var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoColorLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 94 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23.07 47.32c0-13.283 10.735-24.089 23.93-24.089V.008C21.084.008 0 21.232 0 47.32c0 26.09 21.084 47.314 47 47.314V71.411c-13.195 0-23.93-10.807-23.93-24.09zM94 70.546c0 26.09-21.084 47.315-47 47.315V94.636c13.195 0 23.93-10.807 23.93-24.09 0-13.284-10.735-24.09-23.93-24.09V23.232c25.916 0 47 21.225 47 47.313z"
  })));
}
export default SvgNoColorLogo;